import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_GLACIER } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/blank.onsets.json' with { type: 'json' };
import normalImported from './imported/blank-normal.circles.json' with { type: 'json' };
import hardImported from './imported/blank-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/blank-extreme.circles.json' with { type: 'json' };

export const BLANK_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'blank',
  baseTitle: "Blank",
  description: "Disfigure's classic NCS melodic dubstep. Snare backbeat, mid-tier challenge.",
  difficulty: 3,
  palette: PALETTE_GLACIER,
  audioSrc: '/audio/circles/blank.mp3',
  attribution: "\"Blank\" by Disfigure [NCS Release] - https://ncs.io/Blank",
  mapper: "skildfrix",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 140, offsetMs: 0, totalBeats: 143 },
    hard: { bpm: 140, offsetMs: 0, totalBeats: 143 },
    extreme: { bpm: 140, offsetMs: 0, totalBeats: 143 },
  },
});
